import { useMutation, useQueryClient } from '@tanstack/react-query';

import { useAvApi } from '@app-velocity/av-api-v2';

export const useDeleteFigmaReportMutation = (
  projectId?: string,
  teamId?: string
) => {
  const { prototypes } = useAvApi();
  const queryClient = useQueryClient();

  return useMutation({
    mutationKey: ['delete-figma-report-mutation', projectId],
    mutationFn: async (prototypeId: string) => {
      if (!projectId) return;

      await prototypes.deleteV2ProjectsPrototypesByProjectIdAndPrototypeId({
        projectId,
        prototypeId,
      });
    },
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: ['workspace-prototypes-infinite', projectId],
      });

      if (teamId) {
        queryClient.invalidateQueries({
          queryKey: ['workspace-prototypes', projectId],
        });
      }
    },
  });
};
